
const resizeAndFit = cy => {
  cy.resize();
  cy.fit();
};

export { resizeAndFit };